import Vue from 'vue'
import App from './App.vue'
import VueFormulate from '@braid/vue-formulate'
import './assets/formulate.css'
import './assets/tabs.scss'
import router from './router'
import device from "vue-device-detector"
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import qrcode from 'tui-vue-qrcode'
import AOS from 'aos'
import 'aos/dist/aos.css'
Vue.component('qrcode', qrcode)
import axios from 'axios'
axios.defaults.baseURL = 'https://fhrweb.ebmtech.com/net/api/'

// axios.defaults.baseURL = 'https://fhrwebt.ebmtech.com/api/'
// axios.defaults.baseURL = 'https://fhrwebt.ebmtech.com:44340/api/'
//axios.defaults.baseURL = 'https://59.125.160.219:443/api/'
//axios.defaults.baseURL = 'https://localhost:44315/api/'
import {i18n} from './plugins/i18n'
import VueMeta from 'vue-meta'
Vue.use(VueMeta)
Vue.use(Vuetify)
Vue.use(device,{})
Vue.use( VueFormulate,  {})
Vue.config.productionTip = false

new Vue({
  
  i18n,
  router,
  created () {
    AOS.init()
  },
  vuetify: new Vuetify(), 
  render: h => h(App)
}).$mount('#app')
